<template>
  <header class="border-bottom border-light px-3 w-auto">
    <Breadcrumbs :breadcrumbs="$navigation.breadcrumbs" />
    <Actions :actions="$navigation.actions" />
  </header>
</template>

<script>
import Breadcrumbs from '@/components/Navigation/Header/Breadcrumbs'
import Actions from '@/components/Navigation/Header/Actions'

export default {
  components: { Breadcrumbs, Actions }
}
</script>

<style lang="scss" scoped>
  @import 'variables';

  header:first-of-type {
    display: flex;
    align-items: center;
    width: 100vw;
    height: calc(#{$header-height} - #{$header-border-bottom-height});
    color: $header-color;
    background-color: $header-background-color;
  }
</style>
